export function isElementVisibleById(id: string) {
  const el = document.getElementById(id);
  return !!el && el.style.visibility !== 'hidden';
}
